<template>
  <el-dialog
    :title="'导入价格协议信息'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
      <el-form-item label="导入模板" prop="name">
          <el-upload
                  ref="upload"
                  :auto-upload="false"
                  drag
                  action
                  :on-change="handleChange"
                  :http-request="upload"
                  :file-list="fileList"
                  multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div cla3ss="el-upload__tip" slot="tip">只能上传xls文件，且不超过500kb</div>
          </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="exportTemplate()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;导出模板
      </el-button>
      <el-button @click="visible = false">
        <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
      </el-button>
      <el-button type="primary" @click="dataFormSubmit()">
        <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  exportTemplate,
  importPriceAgreement
} from '@/controller/priceAgreement'
  export default {
    data () {
      return {
        fileList:[],
        initValue: {
          tenantlist: []
        },
        visible: false,
        dataForm: {
          tenant: ''
        }
      }
    },
    methods: {
      init () {
        this.visible = true
      },
      // 导出模板
      exportTemplate() {
          exportTemplate().then((data) => {
                this.readAsBinaryString(data.body)
          })
      },
      upload(obj) {
           let formData = new FormData()
           formData.set('file', obj.file)
           importPriceAgreement(formData).then((data) => {
               this.$refs.upload.clearFiles()
              if(data.code === '00'){
                  this.$message.success({
                      message: '导入成功',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                          this.visible = false
                          this.$emit("refreshDataList")
                      }
                  })
              } else {
                 this.$message.error(data.msg);
                 this.visible = false
              }
           }).catch((e) => {
             this.visible = false
             this.$message.error(e);
           }) 
      },
      readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
      },
      str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
      },
      // 表单提交
      dataFormSubmit() {
          this.$refs['dataForm'].validate((valid) => {
              if (valid) {
                  this.$refs.upload.submit();
              }
          })
      },
      handleChange(file, fileList){
        this.fileList = fileList.slice(-1);
      }
    }
  }
</script>
